export interface CampaignCopy {
    headline: string;
    subheadline: string;
    intro: string;
    details: string[];
    note?: string;
}

/**
 * Copy overrides for campaign landing pages, keyed by the :campaign route slug.
 * Unknown slugs fall back to the default Orthotic Assessment copy (see CampaignOrthoticAssessment.tsx).
 */
export const campaigns: Record<string, CampaignCopy> = {
    'back-on-your-feet': {
        headline: 'Get back on your feet (without the pain)',
        subheadline: 'Book your appointment for custom orthotics from Kintec — so you can get to work, free of foot and lower-back pain.',
        intro: "When you book a visit with our pedorthist, you'll get:",
        details: [
            '45-60 minute appointment',
            'Review of lifestyle, symptoms, and relevant history',
            'Biomechanical examination with gait analysis',
            'Personalized treatment plan including orthotics, footwear, activity modification, and soft-tissue management',
            'Access to Kiwi follow-up system to ensure your recovery'
        ],
        note: 'Using Green Shield, WSIB, ODSP, VAC/CAF or another 3rd party provider? Please indicate so in the additional comments. We will reach out if necessary.'
    },
    'stand-against-pain': {
        headline: 'Take a stand against foot pain.',
        subheadline: 'The pain stops here. Book your appointment.',
        intro: "Help is one appointment away. Schedule a time with one of our expert pedorthists at our Oakville clinic. " +
            "Within a few weeks, you'll have your custom-made, game-changing orthotics.\n\nFill out the form below to get started.",
        details: []
    }
};

export const getCampaignCopy = (slug?: string): CampaignCopy | undefined => {
    if (!slug) {
        return undefined;
    }

    return campaigns[slug];
};
